"use client";
import * as React from "react";
import { useState } from "react";

type ItemListProps = {
  label: string;
  inputType: "text" | "url" | "number" | "password";
  classNames?: {
    label?: string;
    input?: string;
  };
  currentlist: string | string[];
  fieldName: string;
  handleItemListUpdate: (fieldName: string, newList: string[]) => void;
};
import ItemRow from "./ItemRow";
import styles from "../index.module.css";
import listStyles from "./index.module.css";
import cssClassAssembler from "../../../sso/utils/cssClassAssembler";
import Button from "../../Button/index";
import ExclamationTriangle from "../../icons/ExclamationTriangle";

function ItemList(props: ItemListProps) {
  const [duplicateEntryIndex, setDuplicateEntryIndex] = useState(
    () => undefined
  );

  function list() {
    return Array.isArray(props.currentlist)
      ? props.currentlist
      : [props.currentlist];
  }

  function addAnother() {
    props.handleItemListUpdate(props.fieldName, [...list(), ""]);
  }

  function handleItemUpdate(newItem: string, index: number) {
    const newList = [...list()];
    newList[index] = newItem;
    props.handleItemListUpdate(props.fieldName, newList);
  }

  function checkDuplicates(index: number) {
    const _item = list()[index];
    // search backwards
    const _firstIndex = list().indexOf(_item);
    if (_firstIndex !== index) {
      setDuplicateEntryIndex(index);
      return;
    } else if (duplicateEntryIndex === index) {
      setDuplicateEntryIndex(undefined);
    }
    // search forwards
    const _nextIndex = list()
      .slice(index + 1)
      .indexOf(_item);
    if (_nextIndex !== -1) {
      setDuplicateEntryIndex(index);
    } else if (duplicateEntryIndex === index) {
      setDuplicateEntryIndex(undefined);
    }
  }

  function handleItemDelete(index: number) {
    const _itemToDelete = list()[index];
    if (
      duplicateEntryIndex !== undefined &&
      (duplicateEntryIndex === index ||
        _itemToDelete === list()[duplicateEntryIndex])
    ) {
      setDuplicateEntryIndex(undefined);
    }
    props.handleItemListUpdate(
      props.fieldName,
      list().filter((_, i) => i !== index)
    );
  }

  function cssClass() {
    return {
      label: cssClassAssembler(props.classNames?.label, styles.label),
      input: cssClassAssembler(props.classNames?.input, styles.input),
    };
  }

  return (
    <fieldset className={styles.fieldset}>
      <legend className={cssClass().label}>{props.label}</legend>
      <div className={listStyles.rowContainer}>
        {list()?.map((item, index) => (
          <div key={index}>
            <ItemRow
              inputType={props.inputType}
              item={item}
              index={index}
              isDuplicateItem={duplicateEntryIndex === index}
              handleItemUpdate={handleItemUpdate}
              handleItemDelete={handleItemDelete}
              disableDelete={index === 0 && list().length === 1}
              handleBlur={checkDuplicates}
              disabled={
                duplicateEntryIndex !== undefined &&
                duplicateEntryIndex !== index
              }
              classNames={{
                input: cssClass().input,
              }}
            />
            {duplicateEntryIndex === index ? (
              <span className={listStyles.error}>
                <ExclamationTriangle
                  svgAttrs={{
                    class: listStyles["svg"],
                    "aria-hidden": true,
                  }}
                />
                Duplicate entries not allowed.
              </span>
            ) : null}
          </div>
        ))}
        <div>
          <Button
            type="button"
            variant="outline"
            name="Add URL"
            classNames={listStyles["add"]}
            onClick={(event) => addAnother()}
            disabled={duplicateEntryIndex !== undefined}
          />
        </div>
      </div>
    </fieldset>
  );
}

export default ItemList;
